/**
 * Progression presentation queue: after a completion the receipt is presented as a chain of
 * overlays (sparks transfer → level up → bonus feature unlocked → stickers received → skill level
 * up → coin piece / path key / path completed → ...) that never collide. Any screen can enqueue.
 */
import { create } from 'zustand';
import type { SparksReceipt } from '@sketchling/core';

export interface Presentation {
  id: number;
  receipt: SparksReceipt;
  profileId: string;
  journalItemId?: string;
  onDone?: () => void;
}

interface Queue {
  items: Presentation[];
  push(p: Omit<Presentation, 'id'>): void;
  shift(): void;
}

let n = 0;
export const usePresentationQueue = create<Queue>((set) => ({
  items: [],
  push: (p) => set((s) => ({ items: [...s.items, { ...p, id: ++n }] })),
  shift: () => set((s) => ({ items: s.items.slice(1) })),
}));

export function presentReceipt(receipt: SparksReceipt, profileId: string, opts: { journalItemId?: string; onDone?: () => void } = {}): void {
  usePresentationQueue.getState().push({ receipt, profileId, ...opts });
}
